import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent {
  @Input() mainTitle: string = '';
  @Input() subTitle: string = '';
  @Input() color: string = '';
  @Input() status: 'success' | 'error' = 'success';
  @Input() view: string | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() viewClick = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onView() {
    this.viewClick.emit();
  }
} 